import { ActionTypes } from "../constants/actionTypes";

const initialState = {
  connectedAccounts: [],
};

export const userConnectedAccounts = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_CONNECTEDACCOUNTS:
      return {
        ...state,
        connectedAccounts: action.payload,
        
      };
    default:
      return state;
  }
};
